export default __webpack_public_path__ + "static/media/index_4.7062f91f.png";